// import React, { useState, Fragment } from "react";
// import "../style.scss";
// const ListToggle = () => {
//   const [showList1, setShowList1] = useState("");
//   const [showList2, setShowList2] = useState("");
//   const [showList3, setShowList3] = useState("");
//   const [showList4, setShowList4] = useState("");
//   const [showList5, setShowList5] = useState("");

//   const toggleList = (listNumber) => {
//     if (listNumber === 1) {
//       setShowList1(!showList1);
//       setShowList2(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 2) {
//       setShowList2(!showList2);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 3) {
//       setShowList3(!showList3);
//       setShowList2(false);
//       setShowList1(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 4) {
//       setShowList4(!showList4);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList2(false);
//       setShowList5(false);
//     } else if (listNumber === 5) {
//       setShowList5(!showList5);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList2(false);
//     }
//   };
//   return (
//     <Fragment>
//       {/* <div className="botam-navbar">
//         <p style="margin-left: 15px; color: #fff">To avail the weekly free training offer <br />Sign up Now.</p>
//         <a href="#corseform" className="active">To know course fee.</a>
//         <a href="#corseform" className="active">Know More</a>
//       </div> */}

//       <div id="main-wrapper">
//         <div className="site-wrapper-reveal">
//           <div
//             className="about-banner-wrap vision-space bg-img responsive_banner_courses"
//           >
//             <div className="container">
//               <div className="row">
//                 <div className="col-lg-6 section-space--pt_100">
//                   <h1 className="mobile-page-heading">AutoCAD Civil/Arch</h1>
//                   <p className="mobile-page-paragraph">
//                     AutoCAD is a powerful drafting software used to create precise 2D Drawings and 3D Models.
//                   </p>
//                 </div>

//                 <div className="col-lg-2"></div>

//                 <div className="col-lg-4">
//                   <div
//                     className="form-container mx-auto mx-xl-0 ml-xl-auto border"
//                     id="corseform"
//                     style={{
//                       marginTop: "20px",
//                       backgroundColor: "white",
//                       alignItems: "center",
//                       marginLeft: "100px",
//                     }}
//                   >
//                     <div id="signup-form">
//                       {/* <p style={{ color: "black" }}>Your Enquiry Successfully Submit</p> */}
//                       <form
//                         id="basic-form"
//                         name="yoursite_wp_mail_from_name"
//                         method="post"
//                       />
//                       <input type="hidden" name="courseId" value="753" />
//                       <input type="hidden" name="category" value="16" />

//                       <div
//                         className="form-group"
//                       // style={{ marginLeft: "60px", marginTop: "30px" }}
//                       >
//                         <label>
//                           Name:
//                           <input
//                             type="text"
//                             id="fname"
//                             name="fname"
//                             className="form-control"
//                             placeholder="Enter Your Name"

//                             required=""
//                           />
//                         </label>
//                       </div>

//                       <div className="form-group">
//                         <label>Email:</label>
//                         <input
//                           type="email"
//                           id="email"
//                           name="email"
//                           className="form-control"
//                           placeholder="Enter Your Email Address"

//                           required=""
//                         />
//                       </div>

//                       <div className="form-group">
//                         <label>Mobile:</label>
//                         <input
//                           type="number"
//                           id="phone"
//                           name="phone"
//                           className="form-control"
//                           placeholder="Enter Your mobile number"

//                           required=""
//                         />
//                       </div>

//                       <div
//                         className="form-group mb-0"
//                       // style={{ marginLeft: "60px" }}
//                       >
//                         <div className="form-row">
//                           <div className="form-group col-6">
//                             <label className="control-label">State</label>
//                             <select
//                               id="states"
//                               name="states"
//                               className="form-control"
//                               required=""
//                             >
//                               <option value="">SELECT STATE</option>
//                               <option value="2">Andhra Pradesh</option>
//                               <option value="5">Bihar</option>
//                               <option value="12">Gujarat</option>
//                               <option value="13">Haryana</option>
//                               <option value="14">Himachal Pradesh</option>
//                               <option value="16">Jharkhand</option>
//                               <option value="17">Karnataka</option>
//                               <option value="17">Kerala</option>

//                               <option value="21">Maharashtra</option>
//                               <option value="28">Punjab</option>
//                               <option value="29">Rajasthan</option>
//                               <option value="31">Tamil Nadu</option>
//                               <option value="32">Telangana</option>
//                               <option value="35">Uttar Pradesh</option>
//                             </select>
//                           </div>

//                           {/* <div className="form-group col-6 city">
//                             <label className="control-label">Center</label>
//                             <select
//                               name="city"
//                               id="city"
//                               className="form-control center"
//                               required=""
//                             >
//                               <option value="">SELECT CENTRE</option>
//                             </select>
//                           </div> */}
//                         </div>
//                       </div>
//                       <div
//                         className="form-group mb-0"
//                         style={{ marginLeft: "130px", paddingBottom: "30px" }}
//                       >
//                         <button
//                           type="submit"
//                           id="btn"
//                           className="btn btn-primary contest_register_now"
//                           name="register_users"
//                         >
//                           Apply Now
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <nav aria-label="breadcrumb">
//         <ol className="breadcrumb">
//           <li className="breadcrumb-item">
//             <a href="/">Home</a>
//           </li>
//           <li className="breadcrumb-item active" aria-current="page">
//             AutoCad
//           </li>
//         </ol>
//       </nav>

//       <div className="vision-overview  " style={{ marginTop: "-180px" }}>
//         <div className="container">
//           <div className="section-title-wrap text-center">
//             <br />
//             <br />
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "25px", color: "#ffc107" }}
//               >
//                 {" "}
//                 Training Highlights
//               </span>
//             </h3>
//           </div>
//           <div className="row">
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Instructor Led Training</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Weekly Doubt clearing Session</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Lifetime Assistance for Revision</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">
//                     Lifetime Login Access to Student Dashboard
//                   </h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">World-Wide Valid Certification</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">
//                     Study Material, Assignments and Projects
//                   </h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <br /> <br />
//           <div
//             className="section-title-wrap text-center"
//             style={{ marginTop: "-140px" }}
//           >
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "30px", color: "#ffc107" }}
//               >
//                 {" "}
//                 Course Highlights
//               </span>
//             </h3>
//           </div>
//           <div className="row">

//             <div className="d-flex flex-row flex-lg-column align-items-lg-center mx-auto">
//               <div className="dashed-border">
//                 <img
//                   className="d-block d-lg-none"
//                   src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_mobile.svg"
//                 />
//                 <img
//                   className="d-none d-lg-block"
//                   src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_desktop.svg"
//                   width={1000}
//                 />
//               </div>

//               <div className="d-flex flex-column  align-items-center flex-lg-row justify-content-lg-center">
//                 <div className="item-container  justify-content-between d-flex flex-lg-column align-items-center ">
//                   <div className="number-container"
//                     style={{ marginLeft: "1px" }}
//                   >
//                     <div className="number-box">1</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       World's Most Popular 2D-Drafting Software
//                     </p>
//                   </div>

//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">2</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       Widely used in all Types of Industries
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">3</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       Productivity Tools and Design Center
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">4</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">Easy to Learn and Use</p>
//                   </div>
//                 </div>

//                 {/* <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">4</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       easy to learn
//                     </p>
//                   </div>
//                 </div> */}


//               </div>
//             </div>
//           </div>
//           <div className="row" style={{ marginTop: "-120px" }}>
//             <div className="col-lg-12">
//               <br />
//               <br />
//               {/* <!-- <h3 className="heading" style="font-size: 21px;">Course Overview</h3> --> */}
//               <h3 className="heading">
//                 <span
//                   className="text-color-primary"
//                   style={{ fontSize: "30px", color: "#ffc107" }}
//                 >
//                   {" "}
//                   Course Overview
//                 </span>
//               </h3>
//               <br />
//               <br />
//               <div>
//                 <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: 'justify' }}>
//                   AutoCAD is a powerful designing and drafting software that is used to create precise 2D drawings and 3D models. AutoCAD Civil course is highly recommended for students who are looking for opportunities in building planning and design. By joining CAD DESK classroom training for AutoCAD Civil, students get an opportunity to learn from our well experienced trainers; who give a great emphasis on delivering quality training to each of its learners.

//                   For learning advanced software, it is suggested that learning AutoCAD gives a strong base to various other 3D modeling and drawing software. CAD DESK provides the best coaching classes to its students in the field of CAD, CAM & CAE. And, while taking the software training for AutoCAD Civil, students are encouraged to do an Internship and also get an opportunity to go for industrial visits.

//                   With CAD DESK, students are flooded with multiple benefits like 100 % Placement assistance and they receive study materials, e-books, tutorials, and projects along with their student panel. They further get a transfer facility option, through which they can move to any of our CAD franchise centers in India; even if they are enrolled at CAD DESK Jaipur or at any other center. After finishing the software training, CAD DESK students get an AutoCAD Civil certificate of course completion that helps them to escalate their careers.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "flex-start",
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <h3 className="heading_course_content">
//             <span
//               className="text-color-primary responsive_course_content"
//             // style={{
//             //   fontSize: "30px",
//             //   color: "#ffc107",
//             //   marginLeft: "200px",
//             // }}
//             >
//               {" "}
//               Course Contents
//             </span>
//           </h3>

//           <div className="row">
//             {" "}

//             <div className="responsive_courese_image_container_mobile_view">
//               <img
//                 src="img/Autop.jpg"
//                 alt="Course Image"
//                 className="responsive_course_image_mobile_view"
//               />
//             </div>

//             <div
//               // style={{
//               //   textAlign: "left",
//               //   marginLeft: "200px",
//               //   color: "black",
//               //   marginTop: "-30px",
//               // }}
//               className="responsive_introduction_container"
//             >
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(1)}
//               // style={{
//               //   backgroundColor: "#ffc107",
//               //   width: "30%",
//               //   borderRadius: "1em",
//               //   marginLeft: "100px",
//               //   margin: "10px auto",
//               //   color: "black",
//               // }}
//               >
//                 {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
//                 {showList1 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i
//                     classNameName="fas fa-arrow-down"
//                     style={{ color: "black" }}
//                   ></i>
//                 )}{" "}
//                 Introduction
//               </button>
//               {showList1 && (
//                 <ul>
//                   <li>Introduction to CAD DESK Kaniyapuram</li>
//                   <li>Introduction to AutoCAD</li>
//                   <li>Fundamentals of Technical Drawings</li>
//                   <li>Theory of Projection</li>
//                   <li>GUI of AutoCAD</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(2)}
//               // style={{
//               //   backgroundColor: "#ffc107",
//               //   width: "30%",
//               //   borderRadius: "1em",
//               //   marginLeft: "100px",
//               //   margin: "10px auto",
//               //   color: "black",
//               // }}
//               >
//                 {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
//                 {showList2 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i
//                     classNameName="fas fa-arrow-down"
//                     style={{ color: "black" }}
//                   ></i>
//                 )}{" "}
//                 Drawing & Annotation tools
//               </button>
//               {showList2 && (
//                 <ul>
//                   <li>Drawing Tools</li>
//                   <li>Drafting Settings</li>
//                   <li>Modify Tools</li>
//                   <li>Dimensions</li>
//                   <li>Texts</li>
//                   <li>Multileader</li>
//                   <li>Tables</li>
//                   <li>Annotation Style Managers</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(3)}
//               // style={{
//               //   backgroundColor: "#ffc107",
//               //   width: "30%",
//               //   borderRadius: "1em",
//               //   marginLeft: "100px",
//               //   margin: "10px auto",
//               //   color: "black",
//               // }}
//               >
//                 {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
//                 {showList3 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i
//                     classNameName="fas fa-arrow-down"
//                     style={{ color: "black" }}
//                   ></i>
//                 )}{" "}
//                 Productivity Tools
//               </button>
//               {showList3 && (
//                 <ul>
//                   <li>Layer Properties Manager</li>
//                   <li>Working with Layers</li>
//                   <li>Isolate and uninsolate any Layer</li>
//                   <li>Design Centre and Tool Pallets</li>
//                   <li>Create and Edit Blocks</li>
//                   <li>Adding and Editing Attributes with Block</li>
//                   <li>Managing Attributes</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(4)}
//               // style={{
//               //   backgroundColor: "#ffc107",
//               //   width: "30%",
//               //   borderRadius: "1em",
//               //   marginLeft: "100px",
//               //   margin: "10px auto",
//               //   color: "black",
//               // }}
//               >
//                 {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
//                 {showList4 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i
//                     classNameName="fas fa-arrow-down"
//                     style={{ color: "black" }}
//                   ></i>
//                 )}{" "}
//                 Advance Tools
//               </button>
//               {showList4 && (
//                 <ul>
//                   <li>Layouts, Page set-up, and Printing</li>
//                   <li>Template Creation</li>
//                   <li>Linking and Extractions</li>
//                   <li>Hatch and Gradients</li>
//                   <li>Parametric Drawings</li>
//                   <li>Isometric drawings</li>
//                   <li>Creating orthographic views using projection</li>
//                   <li>Import and Export</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(5)}
//               // style={{
//               //   backgroundColor: "#ffc107",
//               //   width: "30%",
//               //   borderRadius: "1em",
//               //   marginLeft: "100px",
//               //   margin: "10px auto",
//               //   color: "black",
//               // }}
//               >
//                 {/* {showList1 ? 'Close List 1' : 'Show List 1'}Button */}{" "}
//                 {showList5 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i
//                     classNameName="fas fa-arrow-down"
//                     style={{ color: "black" }}
//                   ></i>
//                 )}
//                 3D modelings{" "}
//               </button>
//               {showList5 && (
//                 <ul>
//                   <li> Workspace Switching</li>
//                   <li>Solid Creation Tools</li>
//                   <li>Solid Editing Tools</li>
//                   <li>Applying Materials</li>
//                   <li>Light and Scene settings</li>
//                   <li>Rendering</li>
//                   <li>Motion Path Animation</li>
//                 </ul>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="responsive_courese_image_container">
//           <img
//             src="img/ACAD.jpg"
//             alt="Course Image"
//             className="responsive_course_image"
//           />
//         </div>

//       </div>

//       <div className="contact-us-section-wrappaer ">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-7 col-lg-7">
//               <div className="conact-us-wrap-one">
//                 <br />
//                 <br />
//                 <h5 className="heading mb-20">
//                   How will you get your certificate?
//                 </h5>
//                 <div className="center_details">
//                   {/* <!--   <h5 className="heading mb-20">CERTIFICATE FAQ</h5> --> */}
//                   <p>
//                     Upon successful completion of the program, each intern
//                     receives a prestigious Digital Marketing Internship
//                     Certificate. This credential not only recognizes their
//                     achievements but also enhances their employability.
//                   </p>
//                   <p style={{ textAlign: "justify" }}>
//                     CAD DESK Kaniyapuram is a pioneer in Mechanical/Civil
//                     training and most of the industries give great recognition
//                     to its certificate throughout India and abroad. CAD DESK
//                     Kaniyapuram Certificates are ISO verified which makes CAD
//                     highly reputed comparing to the other local brands and helps
//                     the student get prioritize while going for job opportunities
//                     in the industry. CAD DESK Kaniyapuram  Software
//                     Training is conducted by highly knowledgeable trainers which
//                     help students to enhance their skill set by putting great
//                     emphasizes on project-based learning.
//                   </p>
//                   {/* <!-- <a className="btn btn-primary">Get Certificate</a> --> */}
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-5 col-lg-5">
//               <div className="contact-form-wrap">
//                 {/* <!-- <h5 className="heading mb-20">How will you get your certificate?</h5> --> */}
//                 <img
//                   src="img/Certificate.png"
//                   style={{
//                     width: " 100%",
//                     marginTop: "100px",
//                     height: "370px",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <br />
//       <br />
//       <br />
//     </Fragment>
//   );
// };

// export default ListToggle;


// import React, { useState, Fragment } from "react";
// import "../style.scss";
// import { Captcha } from "../Components/Captcha"; // adjust path as needed
// import  Slide  from "../Components/Slide.js"; 

// const ListToggle = () => {
//   const [showList1, setShowList1] = useState("");
//   const [showList2, setShowList2] = useState("");
//   const [showList3, setShowList3] = useState("");
//   const [showList4, setShowList4] = useState("");
//   const [showList5, setShowList5] = useState("");
//   const [captchaVerified, setCaptchaVerified] = useState(false);

//   const toggleList = (listNumber) => {
//     if (listNumber === 1) {
//       setShowList1(!showList1);
//       setShowList2(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 2) {
//       setShowList2(!showList2);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 3) {
//       setShowList3(!showList3);
//       setShowList2(false);
//       setShowList1(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 4) {
//       setShowList4(!showList4);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList2(false);
//       setShowList5(false);
//     } else if (listNumber === 5) {
//       setShowList5(!showList5);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList2(false);
//     }
//   };

//   const handleApplyNow = (e) => {
//     if (!captchaVerified) {
//       e.preventDefault();
//       alert("Please verify the CAPTCHA before submitting.");
//     }
//   };

//   return (
//     <Fragment>
//       <div id="main-wrapper">
//         <div className="site-wrapper-reveal">
//           <div className="about-banner-wrap vision-space bg-img responsive_banner_courses">
//             <div className="container">
//               <div className="row">
//                 <div className="col-lg-6 section-space--pt_100">
//                   <h1 className="mobile-page-heading">AutoCAD Civil/Arch</h1>
//                   <p className="mobile-page-paragraph">
//                     AutoCAD is a powerful drafting software used to create precise 2D Drawings and 3D Models.
//                   </p>
//                 </div>

//                 <div className="col-lg-2"></div>

//                 <div className="col-lg-4">
//                   <div
//                     className="form-container mx-auto mx-xl-0 ml-xl-auto border"
//                     id="corseform"
//                     style={{
//                       marginTop: "20px",
//                       backgroundColor: "white",
//                       alignItems: "center",
//                       marginLeft: "100px",
//                     }}
//                   >
//                     <div id="signup-form">
                      
                      

                     




//                       <Slide />
//                     </div>
                    
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <nav aria-label="breadcrumb">
//         <ol className="breadcrumb">
//           <li className="breadcrumb-item">
//             <a href="/">Home</a>
//           </li>
//           <li className="breadcrumb-item active" aria-current="page">
//             AutoCad
//           </li>
//         </ol>
//       </nav>

//       <div className="vision-overview  " style={{ marginTop: "-180px" }}>
//         <div className="container">
//           <div className="section-title-wrap text-center">
//             <br />
//             <br />
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "25px", color: "#ffc107" }}
//               >
//                 {" "}
//                 Training Highlights
//               </span>
//             </h3>
//           </div>
//           <div className="row">
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Instructor Led Training</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Weekly Doubt clearing Session</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Lifetime Assistance for Revision</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">
//                     Lifetime Login Access to Student Dashboard
//                   </h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">World-Wide Valid Certification</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">
//                     Study Material, Assignments and Projects
//                   </h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <br /> <br />
//           <div
//             className="section-title-wrap text-center"
//             style={{ marginTop: "-140px" }}
//           >
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "30px", color: "#ffc107" }}
//               >
//                 {" "}
//                 Course Highlights
//               </span>
//             </h3>
//           </div>
//           <div className="row">
//             <div className="d-flex flex-row flex-lg-column align-items-lg-center mx-auto">
//               <div className="dashed-border">
//                 <img
//                   className="d-block d-lg-none"
//                   src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_mobile.svg"
//                 />
//                 <img
//                   className="d-none d-lg-block"
//                   src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_desktop.svg"
//                   width={1000}
//                 />
//               </div>

//               <div className="d-flex flex-column  align-items-center flex-lg-row justify-content-lg-center">
//                 <div className="item-container  justify-content-between d-flex flex-lg-column align-items-center ">
//                   <div className="number-container" style={{ marginLeft: "1px" }}>
//                     <div className="number-box">1</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       World's Most Popular 2D-Drafting Software
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">2</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       Widely used in all Types of Industries
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">3</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       Productivity Tools and Design Center
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">4</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">Easy to Learn and Use</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="row" style={{ marginTop: "-120px" }}>
//             <div className="col-lg-12">
//               <br />
//               <br />
//               <h3 className="heading">
//                 <span
//                   className="text-color-primary"
//                   style={{ fontSize: "30px", color: "#ffc107" }}
//                 >
//                   {" "}
//                   Course Overview
//                 </span>
//               </h3>
//               <br />
//               <br />
//               <div>
//                 <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: "justify" }}>
//                   AutoCAD is a powerful designing and drafting software that is used to create precise 2D drawings and 3D models. AutoCAD Civil course is highly recommended for students who are looking for opportunities in building planning and design. By joining CAD DESK classroom training for AutoCAD Civil, students get an opportunity to learn from our well experienced trainers; who give a great emphasis on delivering quality training to each of its learners.

//                   For learning advanced software, it is suggested that learning AutoCAD gives a strong base to various other 3D modeling and drawing software. CAD DESK provides the best coaching classes to its students in the field of CAD, CAM & CAE. And, while taking the software training for AutoCAD Civil, students are encouraged to do an Internship and also get an opportunity to go for industrial visits.

//                   With CAD DESK, students are flooded with multiple benefits like 100 % Placement assistance and they receive study materials, e-books, tutorials, and projects along with their student panel. They further get a transfer facility option, through which they can move to any of our CAD franchise centers in India; even if they are enrolled at CAD DESK Jaipur or at any other center. After finishing the software training, CAD DESK students get an AutoCAD Civil certificate of course completion that helps them to escalate their careers.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "flex-start",
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <h3 className="heading_course_content">
//             <span className="text-color-primary responsive_course_content">
//               {" "}
//               Course Contents
//             </span>
//           </h3>

//           <div className="row">
//             <div className="responsive_courese_image_container_mobile_view">
//               <img
//                 src="img/Autop.jpg"
//                 alt="Course Image"
//                 className="responsive_course_image_mobile_view"
//               />
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(1)}
//               >
//                 {showList1 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Introduction
//               </button>
//               {showList1 && (
//                 <ul>
//                   <li>Introduction to CAD DESK Kaniyapuram</li>
//                   <li>Introduction to AutoCAD</li>
//                   <li>Fundamentals of Technical Drawings</li>
//                   <li>Theory of Projection</li>
//                   <li>GUI of AutoCAD</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(2)}
//               >
//                 {showList2 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Drawing & Annotation tools
//               </button>
//               {showList2 && (
//                 <ul>
//                   <li>Drawing Tools</li>
//                   <li>Drafting Settings</li>
//                   <li>Modify Tools</li>
//                   <li>Dimensions</li>
//                   <li>Texts</li>
//                   <li>Multileader</li>
//                   <li>Tables</li>
//                   <li>Annotation Style Managers</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(3)}
//               >
//                 {showList3 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Productivity Tools
//               </button>
//               {showList3 && (
//                 <ul>
//                   <li>Layer Properties Manager</li>
//                   <li>Working with Layers</li>
//                   <li>Isolate and uninsolate any Layer</li>
//                   <li>Design Centre and Tool Pallets</li>
//                   <li>Create and Edit Blocks</li>
//                   <li>Adding and Editing Attributes with Block</li>
//                   <li>Managing Attributes</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(4)}
//               >
//                 {showList4 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Advance Tools
//               </button>
//               {showList4 && (
//                 <ul>
//                   <li>Layouts, Page set-up, and Printing</li>
//                   <li>Template Creation</li>
//                   <li>Linking and Extractions</li>
//                   <li>Hatch and Gradients</li>
//                   <li>Parametric Drawings</li>
//                   <li>Isometric drawings</li>
//                   <li>Creating orthographic views using projection</li>
//                   <li>Import and Export</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(5)}
//               >
//                 {showList5 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}
//                 3D modelings{" "}
//               </button>
//               {showList5 && (
//                 <ul>
//                   <li> Workspace Switching</li>
//                   <li>Solid Creation Tools</li>
//                   <li>Solid Editing Tools</li>
//                   <li>Applying Materials</li>
//                   <li>Light and Scene settings</li>
//                   <li>Rendering</li>
//                   <li>Motion Path Animation</li>
//                 </ul>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="responsive_courese_image_container">
//           <img
//             src="img/ACAD.jpg"
//             alt="Course Image"
//             className="responsive_course_image"
//           />
//         </div>
//       </div>

//       <div className="contact-us-section-wrappaer ">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-7 col-lg-7">
//               <div className="conact-us-wrap-one">
//                 <br />
//                 <br />
//                 <h5 className="heading mb-20">
//                   How will you get your certificate?
//                 </h5>
//                 <div className="center_details">
//                   <p>
//                     Upon successful completion of the program, each intern
//                     receives a prestigious Digital Marketing Internship
//                     Certificate. This credential not only recognizes their
//                     achievements but also enhances their employability.
//                   </p>
//                   <p style={{ textAlign: "justify" }}>
//                     CAD DESK Kaniyapuram is a pioneer in Mechanical/Civil
//                     training and most of the industries give great recognition
//                     to its certificate throughout India and abroad. CAD DESK
//                     Kaniyapuram Certificates are ISO verified which makes CAD
//                     highly reputed comparing to the other local brands and helps
//                     the student get prioritize while going for job opportunities
//                     in the industry. CAD DESK Kaniyapuram Software
//                     Training is conducted by highly knowledgeable trainers which
//                     help students to enhance their skill set by putting great
//                     emphasizes on project-based learning.
//                   </p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-5 col-lg-5">
//               <div className="contact-form-wrap">
//                 <img
//                   src="img/Certificate.png"
//                   style={{
//                     width: " 100%",
//                     marginTop: "100px",
//                     height: "370px",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <br />
//       <br />
//       <br />
//     </Fragment>
//   );
// };

// export default ListToggle;


// import React, { useState, Fragment } from "react";
// import "../style.scss";
// import EnquiryForms from "../Components/Slide.js"; // ← use standalone form, no sliding panel

// const ListToggle = () => {
//   const [showList1, setShowList1] = useState("");
//   const [showList2, setShowList2] = useState("");
//   const [showList3, setShowList3] = useState("");
//   const [showList4, setShowList4] = useState("");
//   const [showList5, setShowList5] = useState("");

//   const toggleList = (listNumber) => {
//     if (listNumber === 1) {
//       setShowList1(!showList1);
//       setShowList2(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 2) {
//       setShowList2(!showList2);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 3) {
//       setShowList3(!showList3);
//       setShowList2(false);
//       setShowList1(false);
//       setShowList4(false);
//       setShowList5(false);
//     } else if (listNumber === 4) {
//       setShowList4(!showList4);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList2(false);
//       setShowList5(false);
//     } else if (listNumber === 5) {
//       setShowList5(!showList5);
//       setShowList1(false);
//       setShowList3(false);
//       setShowList4(false);
//       setShowList2(false);
//     }
//   };

//   return (
//     <Fragment>
//       <div id="main-wrapper">
//         <div className="site-wrapper-reveal">
//           <div className="about-banner-wrap vision-space bg-img responsive_banner_courses">
//             <div className="container">
//               <div className="row">
//                 <div className="col-lg-6 section-space--pt_100">
//                   <h1 className="mobile-page-heading">AutoCAD Civil/Arch</h1>
//                   <p className="mobile-page-paragraph">
//                     AutoCAD is a powerful drafting software used to create precise 2D Drawings and 3D Models.
//                   </p>
//                 </div>

//                 <div className="col-lg-2"></div>

//                 <div className="col-lg-4">
//                   <div
//                     className="form-container mx-auto mx-xl-0 ml-xl-auto border"
//                     id="corseform"
//                     style={{
//                       marginTop: "20px",
//                       backgroundColor: "white",
//                       alignItems: "center",
//                       marginLeft: "100px",
//                     }}
//                   >
//                     {/* ✅ EnquiryForm without category — works as a normal inline form */}
//                     <EnquiryForms showCategory={false} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <nav aria-label="breadcrumb">
//         <ol className="breadcrumb">
//           <li className="breadcrumb-item">
//             <a href="/">Home</a>
//           </li>
//           <li className="breadcrumb-item active" aria-current="page">
//             AutoCad
//           </li>
//         </ol>
//       </nav>

//       <div className="vision-overview  " style={{ marginTop: "-180px" }}>
//         <div className="container">
//           <div className="section-title-wrap text-center">
//             <br />
//             <br />
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "25px", color: "#ffc107" }}
//               >
//                 {" "}
//                 Training Highlights
//               </span>
//             </h3>
//           </div>
//           <div className="row">
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Instructor Led Training</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Weekly Doubt clearing Session</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">Lifetime Assistance for Revision</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">
//                     Lifetime Login Access to Student Dashboard
//                   </h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">World-Wide Valid Certification</h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-lg-4">
//               <div className="item-container d-flex align-items-center">
//                 <div className="image-container">
//                   <img
//                     src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg"
//                     className="lazy-load"
//                   />
//                 </div>
//                 <div className="content-container">
//                   <h3 className="title">
//                     Study Material, Assignments and Projects
//                   </h3>
//                   <p className="description"></p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <br /> <br />
//           <div
//             className="section-title-wrap text-center"
//             style={{ marginTop: "-140px" }}
//           >
//             <h3 className="heading">
//               <span
//                 className="text-color-primary"
//                 style={{ fontSize: "30px", color: "#ffc107" }}
//               >
//                 {" "}
//                 Course Highlights
//               </span>
//             </h3>
//           </div>
//           <div className="row">
//             <div className="d-flex flex-row flex-lg-column align-items-lg-center mx-auto">
//               <div className="dashed-border">
//                 <img
//                   className="d-block d-lg-none"
//                   src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_mobile.svg"
//                 />
//                 <img
//                   className="d-none d-lg-block"
//                   src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_desktop.svg"
//                   width={1000}
//                 />
//               </div>

//               <div className="d-flex flex-column  align-items-center flex-lg-row justify-content-lg-center">
//                 <div className="item-container  justify-content-between d-flex flex-lg-column align-items-center ">
//                   <div className="number-container" style={{ marginLeft: "1px" }}>
//                     <div className="number-box">1</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       World's Most Popular 2D-Drafting Software
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">2</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       Widely used in all Types of Industries
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">3</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">
//                       Productivity Tools and Design Center
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item-container d-flex flex-lg-column align-items-center">
//                   <div className="number-container">
//                     <div className="number-box">4</div>
//                     <div className="arrow-container">
//                       <div className="arrow arrow-left"></div>
//                       <div className="arrow arrow-right"></div>
//                     </div>
//                   </div>
//                   <div className="content-container">
//                     <p className="activity">Easy to Learn and Use</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="row" style={{ marginTop: "-120px" }}>
//             <div className="col-lg-12">
//               <br />
//               <br />
//               <h3 className="heading">
//                 <span
//                   className="text-color-primary"
//                   style={{ fontSize: "30px", color: "#ffc107" }}
//                 >
//                   {" "}
//                   Course Overview
//                 </span>
//               </h3>
//               <br />
//               <br />
//               <div>
//                 <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: "justify" }}>
//                   AutoCAD is a powerful designing and drafting software that is used to create precise 2D drawings and 3D models. AutoCAD Civil course is highly recommended for students who are looking for opportunities in building planning and design. By joining CAD DESK classroom training for AutoCAD Civil, students get an opportunity to learn from our well experienced trainers; who give a great emphasis on delivering quality training to each of its learners.

//                   For learning advanced software, it is suggested that learning AutoCAD gives a strong base to various other 3D modeling and drawing software. CAD DESK provides the best coaching classes to its students in the field of CAD, CAM & CAE. And, while taking the software training for AutoCAD Civil, students are encouraged to do an Internship and also get an opportunity to go for industrial visits.

//                   With CAD DESK, students are flooded with multiple benefits like 100 % Placement assistance and they receive study materials, e-books, tutorials, and projects along with their student panel. They further get a transfer facility option, through which they can move to any of our CAD franchise centers in India; even if they are enrolled at CAD DESK Jaipur or at any other center. After finishing the software training, CAD DESK students get an AutoCAD Civil certificate of course completion that helps them to escalate their careers.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "flex-start",
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <h3 className="heading_course_content">
//             <span className="text-color-primary responsive_course_content">
//               {" "}
//               Course Contents
//             </span>
//           </h3>

//           <div className="row">
//             <div className="responsive_courese_image_container_mobile_view">
//               <img
//                 src="img/Autop.jpg"
//                 alt="Course Image"
//                 className="responsive_course_image_mobile_view"
//               />
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(1)}
//               >
//                 {showList1 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Introduction
//               </button>
//               {showList1 && (
//                 <ul>
//                   <li>Introduction to CAD DESK Kaniyapuram</li>
//                   <li>Introduction to AutoCAD</li>
//                   <li>Fundamentals of Technical Drawings</li>
//                   <li>Theory of Projection</li>
//                   <li>GUI of AutoCAD</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(2)}
//               >
//                 {showList2 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Drawing & Annotation tools
//               </button>
//               {showList2 && (
//                 <ul>
//                   <li>Drawing Tools</li>
//                   <li>Drafting Settings</li>
//                   <li>Modify Tools</li>
//                   <li>Dimensions</li>
//                   <li>Texts</li>
//                   <li>Multileader</li>
//                   <li>Tables</li>
//                   <li>Annotation Style Managers</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(3)}
//               >
//                 {showList3 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Productivity Tools
//               </button>
//               {showList3 && (
//                 <ul>
//                   <li>Layer Properties Manager</li>
//                   <li>Working with Layers</li>
//                   <li>Isolate and uninsolate any Layer</li>
//                   <li>Design Centre and Tool Pallets</li>
//                   <li>Create and Edit Blocks</li>
//                   <li>Adding and Editing Attributes with Block</li>
//                   <li>Managing Attributes</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(4)}
//               >
//                 {showList4 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}{" "}
//                 Advance Tools
//               </button>
//               {showList4 && (
//                 <ul>
//                   <li>Layouts, Page set-up, and Printing</li>
//                   <li>Template Creation</li>
//                   <li>Linking and Extractions</li>
//                   <li>Hatch and Gradients</li>
//                   <li>Parametric Drawings</li>
//                   <li>Isometric drawings</li>
//                   <li>Creating orthographic views using projection</li>
//                   <li>Import and Export</li>
//                 </ul>
//               )}
//             </div>

//             <div className="responsive_introduction_container">
//               <button
//                 className=" collapsed responsive_introduction_button"
//                 data-toggle="collapse"
//                 data-target="#collapse__111"
//                 aria-expanded="false"
//                 aria-controls="collapse__111"
//                 onClick={() => toggleList(5)}
//               >
//                 {showList5 ? (
//                   <i classNameName="fas fa-arrow-up"></i>
//                 ) : (
//                   <i classNameName="fas fa-arrow-down" style={{ color: "black" }}></i>
//                 )}
//                 3D modelings{" "}
//               </button>
//               {showList5 && (
//                 <ul>
//                   <li> Workspace Switching</li>
//                   <li>Solid Creation Tools</li>
//                   <li>Solid Editing Tools</li>
//                   <li>Applying Materials</li>
//                   <li>Light and Scene settings</li>
//                   <li>Rendering</li>
//                   <li>Motion Path Animation</li>
//                 </ul>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="responsive_courese_image_container">
//           <img
//             src="img/ACAD.jpg"
//             alt="Course Image"
//             className="responsive_course_image"
//           />
//         </div>
//       </div>

//       <div className="contact-us-section-wrappaer ">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-7 col-lg-7">
//               <div className="conact-us-wrap-one">
//                 <br />
//                 <br />
//                 <h5 className="heading mb-20">
//                   How will you get your certificate?
//                 </h5>
//                 <div className="center_details">
//                   <p>
//                     Upon successful completion of the program, each intern
//                     receives a prestigious Digital Marketing Internship
//                     Certificate. This credential not only recognizes their
//                     achievements but also enhances their employability.
//                   </p>
//                   <p style={{ textAlign: "justify" }}>
//                     CAD DESK Kaniyapuram is a pioneer in Mechanical/Civil
//                     training and most of the industries give great recognition
//                     to its certificate throughout India and abroad. CAD DESK
//                     Kaniyapuram Certificates are ISO verified which makes CAD
//                     highly reputed comparing to the other local brands and helps
//                     the student get prioritize while going for job opportunities
//                     in the industry. CAD DESK Kaniyapuram Software
//                     Training is conducted by highly knowledgeable trainers which
//                     help students to enhance their skill set by putting great
//                     emphasizes on project-based learning.
//                   </p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-5 col-lg-5">
//               <div className="contact-form-wrap">
//                 <img
//                   src="img/Certificate.png"
//                   style={{
//                     width: " 100%",
//                     marginTop: "100px",
//                     height: "370px",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <br />
//       <br />
//       <br />
//     </Fragment>
//   );
// };

// export default ListToggle;


import React, { useState, Fragment } from "react";
import "../style.scss";
import EnquiryForms from "../Components/Slide.js";

const ListToggle = () => {
  const [showList1, setShowList1] = useState("");
  const [showList2, setShowList2] = useState("");
  const [showList3, setShowList3] = useState("");
  const [showList4, setShowList4] = useState("");
  const [showList5, setShowList5] = useState("");

  const toggleList = (listNumber) => {
    if (listNumber === 1) {
      setShowList1(!showList1);
      setShowList2(false);
      setShowList3(false);
      setShowList4(false);
      setShowList5(false);
    } else if (listNumber === 2) {
      setShowList2(!showList2);
      setShowList1(false);
      setShowList3(false);
      setShowList4(false);
      setShowList5(false);
    } else if (listNumber === 3) {
      setShowList3(!showList3);
      setShowList2(false);
      setShowList1(false);
      setShowList4(false);
      setShowList5(false);
    } else if (listNumber === 4) {
      setShowList4(!showList4);
      setShowList1(false);
      setShowList3(false);
      setShowList2(false);
      setShowList5(false);
    } else if (listNumber === 5) {
      setShowList5(!showList5);
      setShowList1(false);
      setShowList3(false);
      setShowList4(false);
      setShowList2(false);
    }
  };

  return (
    <Fragment>
      <div id="main-wrapper">
        <div className="site-wrapper-reveal">
          <div className="about-banner-wrap vision-space bg-img responsive_banner_courses">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 section-space--pt_100">
                  <h1 className="mobile-page-heading">AutoCAD Civil/Arch</h1>
                  <p className="mobile-page-paragraph">
                    AutoCAD is a powerful drafting software used to create precise 2D Drawings and 3D Models.
                  </p>
                </div>

                <div className="col-lg-2"></div>

                <div className="col-lg-4">
                  <div
                    className="form-container mx-auto mx-xl-0 ml-xl-auto border"
                    id="corseform"
                    style={{
                      marginTop: "20px",
                      backgroundColor: "white",
                      alignItems: "center",
                      marginLeft: "100px",
                    }}
                  >
                    {/*
                      ✅ KEY FIX:
                      - courseName="AutoCAD Civil/Arch" → backend email will show:
                          Applied For Course: AutoCAD Civil/Arch
                          Category: Civil/Architecture CAD
                          Course Selected: AutoCAD Civil/Arch
                      - showCategory={false} → hides category/course dropdowns from user
                        (auto-detected silently from courseName via COURSE_CATEGORY_MAP)
                    */}
                    <EnquiryForms
                      courseName="AutoCAD Civil/Arch"
                      showCategory={false}
                      formType="Applied"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            AutoCad
          </li>
        </ol>
      </nav>

      <div className="vision-overview  " style={{ marginTop: "-180px" }}>
        <div className="container">
          <div className="section-title-wrap text-center">
            <br />
            <br />
            <h3 className="heading">
              <span
                className="text-color-primary"
                style={{ fontSize: "25px", color: "#ffc107" }}
              >
                {" "}
                Training Highlights
              </span>
            </h3>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="item-container d-flex align-items-center">
                <div className="image-container">
                  <img
                    src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-training.svg"
                    className="lazy-load"
                  />
                </div>
                <div className="content-container">
                  <h3 className="title">Instructor Led Training</h3>
                  <p className="description"></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="item-container d-flex align-items-center">
                <div className="image-container">
                  <img
                    src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-drawer.svg"
                    className="lazy-load"
                  />
                </div>
                <div className="content-container">
                  <h3 className="title">Weekly Doubt clearing Session</h3>
                  <p className="description"></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="item-container d-flex align-items-center">
                <div className="image-container">
                  <img
                    src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-assignments.svg"
                    className="lazy-load"
                  />
                </div>
                <div className="content-container">
                  <h3 className="title">Lifetime Assistance for Revision</h3>
                  <p className="description"></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="item-container d-flex align-items-center">
                <div className="image-container">
                  <img
                    src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-dashboard.svg"
                    className="lazy-load"
                  />
                </div>
                <div className="content-container">
                  <h3 className="title">
                    Lifetime Login Access to Student Dashboard
                  </h3>
                  <p className="description"></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="item-container d-flex align-items-center">
                <div className="image-container">
                  <img
                    src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-certificate.svg"
                    className="lazy-load"
                  />
                </div>
                <div className="content-container">
                  <h3 className="title">World-Wide Valid Certification</h3>
                  <p className="description"></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="item-container d-flex align-items-center">
                <div className="image-container">
                  <img
                    src="https://caddeskindia.com/online-training/wp-content/themes/CadDeskTraining/assets/images/icon-report.svg"
                    className="lazy-load"
                  />
                </div>
                <div className="content-container">
                  <h3 className="title">
                    Study Material, Assignments and Projects
                  </h3>
                  <p className="description"></p>
                </div>
              </div>
            </div>
          </div>
          <br /> <br />
          <div
            className="section-title-wrap text-center"
            style={{ marginTop: "-140px" }}
          >
            <h3 className="heading">
              <span
                className="text-color-primary"
                style={{ fontSize: "30px", color: "#ffc107" }}
              >
                {" "}
                Course Highlights
              </span>
            </h3>
          </div>
          <div className="row">
            <div className="d-flex flex-row flex-lg-column align-items-lg-center mx-auto">
              {/* <div className="dashed-border">
                <img
                  className="d-block d-lg-none"
                  src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_mobile.svg"
                />
                <img
                  className="d-none d-lg-block"
                  src="https://itdeskindia.com/wp-content/themes/itdesk_theme/assets/images/dotted_line_desktop.svg"
                  width={1000}
                />
              </div> */}

              <div className="d-flex flex-column  align-items-start flex-lg-row justify-content-lg-center">
                <div className="item-container  justify-content-between d-flex flex-lg-column align-items-center ">
                  <div className="number-container" style={{ marginLeft: "1px" }}>
                    <div className="number-box">1</div>
                    <div className="arrow-container">
                      <div className="arrow arrow-left"></div>
                      <div className="arrow arrow-right"></div>
                    </div>
                  </div>
                  <div className="content-container">
                    <p className="activity">
                      World's Most Popular 2D-Drafting Software
                    </p>
                  </div>
                </div>

                <div className="item-container d-flex flex-lg-column align-items-center">
                  <div className="number-container">
                    <div className="number-box">2</div>
                    <div className="arrow-container">
                      <div className="arrow arrow-left"></div>
                      <div className="arrow arrow-right"></div>
                    </div>
                  </div>
                  <div className="content-container">
                    <p className="activity">
                      Widely used in all Types of Industries
                    </p>
                  </div>
                </div>

                <div className="item-container d-flex flex-lg-column align-items-center">
                  <div className="number-container">
                    <div className="number-box">3</div>
                    <div className="arrow-container">
                      <div className="arrow arrow-left"></div>
                      <div className="arrow arrow-right"></div>
                    </div>
                  </div>
                  <div className="content-container">
                    <p className="activity">
                      Productivity Tools and Design Center
                    </p>
                  </div>
                </div>

                <div className="item-container d-flex flex-lg-column align-items-center">
                  <div className="number-container">
                    <div className="number-box">4</div>
                    <div className="arrow-container">
                      <div className="arrow arrow-left"></div>
                      <div className="arrow arrow-right"></div>
                    </div>
                  </div>
                  <div className="content-container">
                    <p className="activity">Easy to Learn and Use</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginTop: "-120px" }}>
            <div className="col-lg-12">
              <br />
              <br />
              <h3 className="heading">
                <span
                  className="text-color-primary"
                  style={{ fontSize: "30px", color: "#ffc107" }}
                >
                  {" "}
                  Course Overview
                </span>
              </h3>
              <br />
              <br />
              <div>
                <p style={{ marginTop: "-70px", fontSize: "15px", textAlign: "justify" }}>
                  AutoCAD is a powerful designing and drafting software that is used to create precise 2D drawings and 3D models. AutoCAD Civil course is highly recommended for students who are looking for opportunities in building planning and design. By joining CAD DESK classroom training for AutoCAD Civil, students get an opportunity to learn from our well experienced trainers; who give a great emphasis on delivering quality training to each of its learners.

                  For learning advanced software, it is suggested that learning AutoCAD gives a strong base to various other 3D modeling and drawing software. CAD DESK provides the best coaching classes to its students in the field of CAD, CAM & CAE. And, while taking the software training for AutoCAD Civil, students are encouraged to do an Internship and also get an opportunity to go for industrial visits.

                  With CAD DESK, students are flooded with multiple benefits like 100 % Placement assistance and they receive study materials, e-books, tutorials, and projects along with their student panel. They further get a transfer facility option, through which they can move to any of our CAD franchise centers in India; even if they are enrolled at CAD DESK Jaipur or at any other center. After finishing the software training, CAD DESK students get an AutoCAD Civil certificate of course completion that helps them to escalate their careers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
        }}
      >
        <div style={{ flex: 1 }}>
          <h3 className="heading_course_content">
            <span className="text-color-primary responsive_course_content">
              {" "}
              Course Contents
            </span>
          </h3>

          <div className="row">
            <div className="responsive_courese_image_container_mobile_view">
              <img
                src="img/Autop.webp"
                alt="Course Image"
                className="responsive_course_image_mobile_view"
              />
            </div>

            <div className="responsive_introduction_container">
              <button
                className=" collapsed responsive_introduction_button"
                data-toggle="collapse"
                data-target="#collapse__111"
                aria-expanded="false"
                aria-controls="collapse__111"
                onClick={() => toggleList(1)}
              >
                {showList1 ? (
                  <i className="fas fa-arrow-up"></i>
                ) : (
                  <i className="fas fa-arrow-down" style={{ color: "black" }}></i>
                )}{" "}
                Introduction
              </button>
              {showList1 && (
                <ul>
                  <li>Introduction to CAD DESK Kaniyapuram</li>
                  <li>Introduction to AutoCAD</li>
                  <li>Fundamentals of Technical Drawings</li>
                  <li>Theory of Projection</li>
                  <li>GUI of AutoCAD</li>
                </ul>
              )}
            </div>

            <div className="responsive_introduction_container">
              <button
                className=" collapsed responsive_introduction_button"
                data-toggle="collapse"
                data-target="#collapse__111"
                aria-expanded="false"
                aria-controls="collapse__111"
                onClick={() => toggleList(2)}
              >
                {showList2 ? (
                  <i className="fas fa-arrow-up"></i>
                ) : (
                  <i className="fas fa-arrow-down" style={{ color: "black" }}></i>
                )}{" "}
                Drawing & Annotation tools
              </button>
              {showList2 && (
                <ul>
                  <li>Drawing Tools</li>
                  <li>Drafting Settings</li>
                  <li>Modify Tools</li>
                  <li>Dimensions</li>
                  <li>Texts</li>
                  <li>Multileader</li>
                  <li>Tables</li>
                  <li>Annotation Style Managers</li>
                </ul>
              )}
            </div>

            <div className="responsive_introduction_container">
              <button
                className=" collapsed responsive_introduction_button"
                data-toggle="collapse"
                data-target="#collapse__111"
                aria-expanded="false"
                aria-controls="collapse__111"
                onClick={() => toggleList(3)}
              >
                {showList3 ? (
                  <i className="fas fa-arrow-up"></i>
                ) : (
                  <i className="fas fa-arrow-down" style={{ color: "black" }}></i>
                )}{" "}
                Productivity Tools
              </button>
              {showList3 && (
                <ul>
                  <li>Layer Properties Manager</li>
                  <li>Working with Layers</li>
                  <li>Isolate and uninsolate any Layer</li>
                  <li>Design Centre and Tool Pallets</li>
                  <li>Create and Edit Blocks</li>
                  <li>Adding and Editing Attributes with Block</li>
                  <li>Managing Attributes</li>
                </ul>
              )}
            </div>

            <div className="responsive_introduction_container">
              <button
                className=" collapsed responsive_introduction_button"
                data-toggle="collapse"
                data-target="#collapse__111"
                aria-expanded="false"
                aria-controls="collapse__111"
                onClick={() => toggleList(4)}
              >
                {showList4 ? (
                  <i className="fas fa-arrow-up"></i>
                ) : (
                  <i className="fas fa-arrow-down" style={{ color: "black" }}></i>
                )}{" "}
                Advance Tools
              </button>
              {showList4 && (
                <ul>
                  <li>Layouts, Page set-up, and Printing</li>
                  <li>Template Creation</li>
                  <li>Linking and Extractions</li>
                  <li>Hatch and Gradients</li>
                  <li>Parametric Drawings</li>
                  <li>Isometric drawings</li>
                  <li>Creating orthographic views using projection</li>
                  <li>Import and Export</li>
                </ul>
              )}
            </div>

            <div className="responsive_introduction_container">
              <button
                className=" collapsed responsive_introduction_button"
                data-toggle="collapse"
                data-target="#collapse__111"
                aria-expanded="false"
                aria-controls="collapse__111"
                onClick={() => toggleList(5)}
              >
                {showList5 ? (
                  <i className="fas fa-arrow-up"></i>
                ) : (
                  <i className="fas fa-arrow-down" style={{ color: "black" }}></i>
                )}
                3D modelings{" "}
              </button>
              {showList5 && (
                <ul>
                  <li> Workspace Switching</li>
                  <li>Solid Creation Tools</li>
                  <li>Solid Editing Tools</li>
                  <li>Applying Materials</li>
                  <li>Light and Scene settings</li>
                  <li>Rendering</li>
                  <li>Motion Path Animation</li>
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="responsive_courese_image_container">
          <img
            src="img/ACAD.webp"
            alt="Course Image"
            className="responsive_course_image"
          />
        </div>
      </div>

      <div className="contact-us-section-wrappaer ">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-lg-7">
              <div className="conact-us-wrap-one">
                <br />
                <br />
                <h5 className="heading mb-20">
                  How will you get your certificate?
                </h5>
                <div className="center_details">
                  <p>
                    Upon successful completion of the program, each intern
                    receives a prestigious Digital Marketing Internship
                    Certificate. This credential not only recognizes their
                    achievements but also enhances their employability.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    CAD DESK Kaniyapuram is a pioneer in Mechanical/Civil
                    training and most of the industries give great recognition
                    to its certificate throughout India and abroad. CAD DESK
                    Kaniyapuram Certificates are ISO verified which makes CAD
                    highly reputed comparing to the other local brands and helps
                    the student get prioritize while going for job opportunities
                    in the industry. CAD DESK Kaniyapuram Software
                    Training is conducted by highly knowledgeable trainers which
                    help students to enhance their skill set by putting great
                    emphasizes on project-based learning.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-lg-5">
              <div className="contact-form-wrap">
                <img
                  src="img/Certificate.png"
                  style={{
                    width: " 100%",
                    marginTop: "100px",
                    height: "370px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
    </Fragment>
  );
};

export default ListToggle;